import { find } from 'lodash';
import { extendMoment } from 'moment-range';
import Moment from 'moment-timezone';

import { ZONES_STATIC, getCurrentTimeZone } from '@/utils/index';

const moment = extendMoment(Moment);

export const strict = false;
export const type = 'time';

export const GET = 'GET';
export const UPDATE = 'UPDATE';
export const UPDATE_DATES = 'UPDATE_DATES';
export const ZONES = 'ZONES';
export const CURRENT_TIME_ZONE = 'CURRENT_TIME_ZONE';
export const DATES = 'DATES';

const SET_CURRENT_TIME_ZONE = 'SET_CURRENT_TIME_ZONE';
const SET_DATES = 'SET_DATES';

export const state = () => {
  const predefinedZone = new URLSearchParams(window.location.search).get('time_zone');
  const currentTimeZone = getCurrentTimeZone(predefinedZone);

  return {
    zones: ZONES_STATIC,
    currentTimeZone: currentTimeZone,
    dates: []
  };
};

export const mutations = {
  [SET_CURRENT_TIME_ZONE](state, value) {
    state.currentTimeZone = value;
  },
  [SET_DATES](state, newDates) {
    state.dates = newDates;
  }
};

export const actions = {
  [UPDATE]({ getters, state, commit }, name) {
    const zone = find(getters[ZONES], { tzCode: name });
    commit(SET_CURRENT_TIME_ZONE, zone);
  },
  [UPDATE_DATES]({ getters, state, commit }, startDate) {
    const range = moment.range(startDate, startDate.clone().endOf('week'));
    const result = [];

    for (const date of range.by('days')) {
      result.push(date);
    }

    commit(SET_DATES, result);
  }
};

export const getters = {
  [ZONES](state, getters) {
    return state.zones;
  },
  [CURRENT_TIME_ZONE](state, getters) {
    return state.currentTimeZone;
  },
  [DATES](state, getters) {
    return state.dates;
  }
};
